module.exports = __webpack_public_path__ + "img/product_category_preview_image-6-b.955a75a.webp";